import $ from "jquery";
import {
	getConfig,
	getContent,
	contentMeta,
	getDynData,
} from "#scripts/general_functions.js";
import { compileContent } from "#scripts/tools/compile_content.js";
import language from "#scripts/translation";

export default function () {
	const config = getConfig();
	const res = window.serverdata.configMeta.aim;
	const logo = res.logo[1];
	let style = "";
	let cssclass = "";
	let height = "";
	let width = "";
	if (logo !== undefined) {
		style =
			logo.inlineStyles && logo.inlineStyles.length > 0
				? `style='${logo.inlineStyles}'`
				: "";
		cssclass = logo.cssclass && logo.cssclass.length > 0 ? logo.cssclass : "";
		height = logo.height !== undefined ? `height='${logo.height}'` : "";
		width = logo.height !== undefined ? `width='${logo?.width}'` : "";
	}

	getContent(config.footer).done((data) => {
		const meta = contentMeta(data);
		const dyndata = getDynData(meta);

		const text1 = dyndata.fritekst_venstre;
		const text3 = dyndata.fritekst_senter;
		let text2 = dyndata.fritekst_hoyre;

		text2 = compileContent(text2, data);

		let leftcolumn = "";

		if (text1) {
			leftcolumn = text1;
		}
		let rightcolumn = "";
		if (text2) {
			rightcolumn = text2;
		}
		let centercolumn = "";
		if (text3) {
			centercolumn = text3;
		}
		const cookieLinkTitle = language("FOOTER_PRIVACY"); // Personvernerklæring og informasjonkapsler';
		const cookieLinkUrl =
			config.cookieLink?.link || "/personvernerklaering-og-informasjonskapsler";

		const showAccessibilityLink = config.showAccessibilityLink ?? false;
		const accessibilityLinkTitle = language("FOOTER_AVAILABILITY"); // 'Tilgjengelighetserklæring';
		const accessibilityLinkUrl =
			config.accessibilityLink?.link || "/tilgjengelighetserklaering";

		const footerHtml = `
            <div class="footer__pre">
            </div>
            <div class="totop__container container">
                <div class="row">
                    <div class="col ">
                        <a href="javascript:window.scrollTo(0,0);" aria-label="Til toppen" class="totop__link d-table">
                            <span class="material-icons-outlined notranslate totop__icon"></span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="footer--container">
                <div class="footer__post">
                    <div class="container p-lg-0">
                        <div class="row">
                            ${config.logoInFooter
				? `
                            <div class="footer__shield-container align-middle">
                                <img class="footer__shield align-middle ${cssclass}" alt="${logo.alttext}" src="${logo.filepath}" ${style} ${height} ${width}> 
                            </div>`
				: ""
			}
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="footer--container--inner footer__content">
                                    <div class="row">
                                        <div class="col-lg-4 ">
                                            ${leftcolumn}
                                        </div>
                                        <div class="col-lg-4">
                                            ${centercolumn}
                                        </div>
                                        <div class="col-lg-4">
                                            ${rightcolumn}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer__cookie">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center  ${showAccessibilityLink
				? "col-lg-6 text-lg-right"
				: "col-lg-12 text-lg-center"
			}">
                                <a href="${cookieLinkUrl}">${cookieLinkTitle}</a>
                            </div>
                            ${showAccessibilityLink
				? `
                            <div class="col-md-12 col-lg-6 text-center text-lg-left">
                                <a href="${accessibilityLinkUrl}">${accessibilityLinkTitle}</a>
                            </div>`
				: ""
			}
                        </div>
                    </div> 
                </div>
            </div>`;

		$("#footer").append(footerHtml);
		let analytics = "";
		if (config.analytics) {
			analytics = config.analytics;

			const gscript = `
            <script async src="https://www.googletagmanager.com/gtag/js?id=${analytics}"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${analytics}');
            </script> `;
			$("body").append(gscript);
		}
	});
}
